import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React, { useState, useEffect } from 'react';
import IcButtonChipsExpandStroke from '../icons/IcButtonChipsExpandStroke.js';
import styles from './ChipsGroup.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
var ChipWrapper = function ChipWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("li", {
    className: cx('menu-item')
  }, children);
};
function ChipsGroup(_ref2) {
  var children = _ref2.children,
    leftSideChip = _ref2.leftSideChip,
    _ref2$isExpanded = _ref2.isExpanded,
    _isExpanded = _ref2$isExpanded === void 0 ? false : _ref2$isExpanded,
    _ref2$isFoldable = _ref2.isFoldable,
    isFoldable = _ref2$isFoldable === void 0 ? false : _ref2$isFoldable;
  var _useState = useState(_isExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  useEffect(function () {
    setIsExpanded(_isExpanded);
  }, [_isExpanded]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', {
      chipsmenu: isFoldable
    }, {
      'is-expanded': isExpanded
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('scroll-inner')
  }, /*#__PURE__*/React.createElement("ul", {
    className: cx('menu-list')
  }, leftSideChip && /*#__PURE__*/React.createElement("li", {
    className: cx('total-area')
  }, leftSideChip), children)), isFoldable && ( /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('fold-button'),
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  }, /*#__PURE__*/React.createElement(IcButtonChipsExpandStroke, {
    width: "34",
    height: "34"
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('blind')
  }, "\uCE74\uD14C\uACE0\uB9AC ", isExpanded ? '열기' : '닫기'))));
}
ChipsGroup.ChipWrapper = ChipWrapper;

export { ChipsGroup as default };
